import { render } from "./Filters.vue?vue&type=template&id=47252042&scoped=true"
import script from "./Filters.vue?vue&type=script&lang=js"
export * from "./Filters.vue?vue&type=script&lang=js"

import "./Filters.vue?vue&type=style&index=0&id=47252042&scoped=true&lang=css"

import exportComponent from "/root/fixed-links/crm-updated/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47252042"]])

export default __exports__